<template>
  <div>

  <xolas-table
  table-ref="landlordstable"

  title="Landlords"
  icon="fa fa-house"

  url="report/property/landlords"
  :fields="fields"

  sort-field="name"

  search-placeholder="Search Landlords..."
  layer-component="propertyLandlord"
  :layer-args="{ id: 'id' }"
  />

</div>
</template>

<script>

import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

export default {
  mixins: [DateMixins, NumberMixins],

  methods: {
    formatExpiry (value) {
      return this.formatFriendlyDate(value, true)
    }
  },

  data () {
    return {
      // Matched to the dev (vuetable-2) render: the Landlord text column is the
      // only flex column (`minWidth`) so it absorbs all slack like dev's auto
      // layout; every other column is a FIXED `width` at its dev px so el-table
      // doesn't bloat them by distributing extra space proportionally. See the
      // dev-parity note in the migration recipe.
      fields: [
        {
          name: '__sequence',
          title: '#',
          width: 36
        },
        {
          name: 'name',
          title: 'Landlord',
          minWidth: 320
        },
        {
          name: 'sites',
          title: 'Sites',
          width: 56
        },
        {
          name: 'started',
          title: 'Started',
          width: 136,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          callback: this.formatDate
        },
        {
          name: 'expiry',
          title: 'Max. Expiry',
          width: 136,
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down',
          callback: this.formatDate
        },
        {
          name: 'avgAmount',
          title: 'Avg. Rental',
          width: 129,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          callback: this.formatNumber
        },
        {
          name: 'totalAmount',
          title: 'Total Rental',
          width: 137,
          callback: this.formatNumber
        },
        {
          name: 'totalDeposit',
          title: 'Total Deposit',
          width: 137,
          titleClass: 'hidden-lg-and-down',
          dataClass: 'hidden-lg-and-down',
          callback: this.formatNumber
        }
      ]
    }
  }

}
</script>

<style>
.dash-heading {
  font-size: 3em;
  color: lightgrey;
  padding-top: 0.852em;
  margin-bottom: 0.528em;
  border-bottom: 1px solid lightgrey}
</style>

<!-- Dev-parity: match the legacy vuetable-2 render — dev <td> uses `12px 0`
     (zero horizontal cell padding) and a tight ~1.25 line-height; el-table's
     defaults are wider/taller. Apply on every migrated table. -->
<style scoped>
::v-deep .el-table th .cell,
::v-deep .el-table td .cell { padding-left: 0; padding-right: 0; }
::v-deep .el-table th .cell { white-space: normal; }
::v-deep .el-table th .cell,
::v-deep .el-table td .cell { line-height: 1.25; }
</style>
